import React from 'react';
import { Card, CardContent } from './ui/card';
import { carBrands } from '../mock';

export const BrandsSection = () => {
  return (
    <section id="brands" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            أنواع السيارات
          </h2>
          <div className="w-24 h-1 bg-blue-900 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            نوفر قطع غيار أصلية لجميع الشاحنات والمركبات التجارية الرائدة
          </p>
        </div>

        {/* Brands Grid - 5 vehicles in 2 rows */}
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {carBrands.map((brand) => (
            <Card
              key={brand.id}
              className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-blue-900 cursor-pointer overflow-hidden"
            >
              <CardContent className="p-0">
                {/* Image Container - Larger for single vehicle */}
                <div className="relative h-80 bg-gradient-to-br from-gray-100 to-gray-50 overflow-hidden">
                  <img
                    src={brand.image}
                    alt={brand.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                
                {/* Content */}
                <div className="p-8 text-center">
                  <h3 className="text-3xl font-bold text-gray-900 mb-3">
                    {brand.name}
                  </h3>
                  <p className="text-lg text-gray-500 mb-4">
                    {brand.nameEnglish}
                  </p>
                  <p className="text-xl text-gray-600">
                    {brand.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="bg-blue-900 text-white rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold mb-4">
              لا تجد ماركة سيارتك؟
            </h3>
            <p className="text-xl text-blue-100 mb-6">
              نتعامل مع العديد من الماركات الأخرى. تواصل معنا وسنوفر لك ما تحتاجه
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-blue-900 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors inline-flex items-center gap-2"
            >
              اتصل بنا الآن
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};